enum ShipStatus {
  Atracados = 'Atracados',
  Desatracados = 'Desatracados',
  Esperados = 'Esperados',
  NaBarra = 'Na Barra',
  Todos = 'Todos',
}

export default ShipStatus;
